export default "__VITE_ASSET__8EejabzZ__"